import { Tabs } from '@heroui/react';
import { useSearchParams } from 'react-router-dom';
import { AiProvidersManagement } from './components/AiProvidersManagement';
import { AiModelsManagement } from './components/AiModelsManagement';
import { AiBillingRulesManagement } from './components/AiBillingRulesManagement';
import { AiInvokeLogsManagement } from './components/AiInvokeLogsManagement';

export const AI_TAB_PROVIDERS = 'providers';
export const AI_TAB_MODELS = 'models';
export const AI_TAB_BILLING_RULES = 'billing-rules';
export const AI_TAB_INVOKE_LOGS = 'invoke-logs';

const VALID_TABS = new Set([
  AI_TAB_PROVIDERS,
  AI_TAB_MODELS,
  AI_TAB_BILLING_RULES,
  AI_TAB_INVOKE_LOGS,
]);

export default function AiPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get('tab') ?? AI_TAB_PROVIDERS;
  const selectedKey = VALID_TABS.has(raw) ? raw : AI_TAB_PROVIDERS;

  return (
    <div className="flex h-full min-h-0 flex-col bg-background">
      <Tabs
        variant="secondary"
        selectedKey={selectedKey}
        className="flex min-h-0 flex-1 flex-col"
        onSelectionChange={(key) => {
          const next = new URLSearchParams(searchParams);
          if (key === AI_TAB_PROVIDERS) {
            next.delete('tab');
          } else {
            next.set('tab', String(key));
          }
          setSearchParams(next, { replace: true });
        }}
      >
        <Tabs.ListContainer className="w-full border-b border-border px-4">
          <Tabs.List
            aria-label="AI 管理"
            className="w-max min-w-0 gap-0 border-0"
          >
            <Tabs.Tab id={AI_TAB_PROVIDERS} className="w-auto">
              AI 供应商
              <Tabs.Indicator />
            </Tabs.Tab>
            <Tabs.Tab id={AI_TAB_MODELS} className="w-auto">
              AI 模型
              <Tabs.Indicator />
            </Tabs.Tab>
            <Tabs.Tab id={AI_TAB_BILLING_RULES} className="w-auto">
              计费规则
              <Tabs.Indicator />
            </Tabs.Tab>
            <Tabs.Tab id={AI_TAB_INVOKE_LOGS} className="w-auto">
              调用统计
              <Tabs.Indicator />
            </Tabs.Tab>
          </Tabs.List>
        </Tabs.ListContainer>
        <Tabs.Panel
          id={AI_TAB_PROVIDERS}
          className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-0"
        >
          <AiProvidersManagement />
        </Tabs.Panel>
        <Tabs.Panel
          id={AI_TAB_MODELS}
          className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-0"
        >
          <AiModelsManagement />
        </Tabs.Panel>
        <Tabs.Panel
          id={AI_TAB_BILLING_RULES}
          className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-0"
        >
          <AiBillingRulesManagement />
        </Tabs.Panel>
        <Tabs.Panel
          id={AI_TAB_INVOKE_LOGS}
          className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-0"
        >
          <AiInvokeLogsManagement />
        </Tabs.Panel>
      </Tabs>
    </div>
  );
}
